import { ISelectedColumns } from './SelectedColumns';

export interface ISegmentMetadataInput {
  segmentId?: number;
  predefinedSegmentId?: string;
  columns?: ISelectedColumns;
}
